export const GET_VIEWS_LIST_REQUEST = "GET_VIEWS_LIST_REQUEST";
export const GET_VIEWS_LIST_SUCCESS = "GET_VIEWS_LIST_SUCCESS";
export const GET_VIEWS_LIST_FAILURE = "GET_VIEWS_LIST_FAILURE";

export const GET_RECENT_VIEWS_REQUEST = "GET_RECENT_VIEWS_REQUEST";
export const GET_RECENT_VIEWS_SUCCESS = "GET_RECENT_VIEWS_SUCCESS";
export const GET_RECENT_VIEWS_FAILURE = "GET_RECENT_VIEWS_FAILURE";

export const GET_VIEW_BY_ID_REQUEST = "GET_VIEW_BY_ID_REQUEST";
export const GET_VIEW_BY_ID_SUCCESS = "GET_VIEW_BY_ID_SUCCESS";
export const GET_VIEW_BY_ID_FAILURE = "GET_VIEW_BY_ID_FAILURE";

export const CREATE_VIEW_REQUEST = "CREATE_VIEW_REQUEST";
export const CREATE_VIEW_SUCCESS = "CREATE_VIEW_SUCCESS";
export const CREATE_VIEW_FAILURE = "CREATE_VIEW_FAILURE";

export const UPDATE_VIEW_REQUEST = "UPDATE_VIEW_REQUEST";
export const UPDATE_VIEW_SUCCESS = "UPDATE_VIEW_SUCCESS";
export const UPDATE_VIEW_FAILURE = "UPDATE_VIEW_FAILURE";

export const DELETE_VIEW_REQUEST = "DELETE_VIEW_REQUEST";
export const DELETE_VIEW_SUCCESS = "DELETE_VIEW_SUCCESS";
export const DELETE_VIEW_FAILURE = "DELETE_VIEW_FAILURE";

export const CLONE_VIEW_REQUEST = "CLONE_VIEW_REQUEST";
export const CLONE_VIEW_SUCCESS = "CLONE_VIEW_SUCCESS";
export const CLONE_VIEW_FAILURE = "CLONE_VIEW_FAILURE";

export const RUN_VIEW_REQUEST = "RUN_VIEW_REQUEST";
export const RUN_VIEW_SUCCESS = "RUN_VIEW_SUCCESS";
export const RUN_VIEW_FAILURE = "RUN_VIEW_FAILURE";

export const GET_VIEW_DATA_REQUEST = "GET_VIEW_DATA_REQUEST";
export const GET_VIEW_DATA_SUCCESS = "GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "GET_VIEW_DATA_FAILURE";

export const GET_VIEW_HISTORY_REQUEST = "GET_VIEW_HISTORY_REQUEST";
export const GET_VIEW_HISTORY_SUCCESS = "GET_VIEW_HISTORY_SUCCESS";
export const GET_VIEW_HISTORY_FAILURE = "GET_VIEW_HISTORY_FAILURE";

export const GET_USER_VIEW_PERMISSION_REQUEST = "GET_USER_VIEW_PERMISSION_REQUEST";
export const GET_USER_VIEW_PERMISSION_SUCCESS = "GET_USER_VIEW_PERMISSION_SUCCESS";
export const GET_USER_VIEW_PERMISSION_FAILURE = "GET_USER_VIEW_PERMISSION_FAILURE";

export const GET_USER_VIEW_RESOURCE_PERMISSION_REQUEST = "GET_USER_VIEW_RESOURCE_PERMISSION_REQUEST";
export const GET_USER_VIEW_RESOURCE_PERMISSION_SUCCESS = "GET_USER_VIEW_RESOURCE_PERMISSION_SUCCESS";
export const GET_USER_VIEW_RESOURCE_PERMISSION_FAILURE = "GET_USER_VIEW_RESOURCE_PERMISSION_FAILURE";

// Action creators

export const getViewsListRequest = (filters = {}, pageKey = null, append = false) => ({
    type: GET_VIEWS_LIST_REQUEST,
    params: { filters, pageKey, append }
});

export const getViewsListSuccess = (result, append = false) => ({
    type: GET_VIEWS_LIST_SUCCESS,
    payload: result,
    append
});

export const getViewsListFailure = (error) => ({
    type: GET_VIEWS_LIST_FAILURE,
    payload: { error }
});

export const getRecentViewsRequest = () => ({
    type: GET_RECENT_VIEWS_REQUEST
});

export const getRecentViewsSuccess = (result) => ({
    type: GET_RECENT_VIEWS_SUCCESS,
    payload: result
});

export const getRecentViewsFailure = (error) => ({
    type: GET_RECENT_VIEWS_FAILURE,
    payload: { error }
});

export const getViewByIdRequest = (viewId) => ({
    type: GET_VIEW_BY_ID_REQUEST,
    params: { viewId }
});

export const getViewByIdSuccess = (view) => ({
    type: GET_VIEW_BY_ID_SUCCESS,
    payload: { view }
});

export const getViewByIdFailure = (error) => ({
    type: GET_VIEW_BY_ID_FAILURE,
    payload: { error }
});

export const createViewRequest = (viewData) => ({
    type: CREATE_VIEW_REQUEST,
    params: { viewData }
});

export const createViewSuccess = (view) => ({
    type: CREATE_VIEW_SUCCESS,
    payload: { view }
});

export const createViewFailure = (error) => ({
    type: CREATE_VIEW_FAILURE,
    payload: { error }
});

export const updateViewRequest = (viewId, updateData) => ({
    type: UPDATE_VIEW_REQUEST,
    params: { viewId, updateData }
});

export const updateViewSuccess = (view) => ({
    type: UPDATE_VIEW_SUCCESS,
    payload: { view }
});

export const updateViewFailure = (error) => ({
    type: UPDATE_VIEW_FAILURE,
    payload: { error }
});

export const deleteViewRequest = (viewId) => ({
    type: DELETE_VIEW_REQUEST,
    params: { viewId }
});

export const deleteViewSuccess = (viewId) => ({
    type: DELETE_VIEW_SUCCESS,
    payload: { viewId }
});

export const deleteViewFailure = (error) => ({
    type: DELETE_VIEW_FAILURE,
    payload: { error }
});

export const cloneViewRequest = (viewId, viewName, description, columnConfig) => ({
    type: CLONE_VIEW_REQUEST,
    params: { viewId, viewName, description, columnConfig }
});

export const cloneViewSuccess = (view) => ({
    type: CLONE_VIEW_SUCCESS,
    payload: { view }
});

export const cloneViewFailure = (error) => ({
    type: CLONE_VIEW_FAILURE,
    payload: { error }
});

export const runViewRequest = (viewId) => ({
    type: RUN_VIEW_REQUEST,
    params: { viewId }
});

export const runViewSuccess = (result) => ({
    type: RUN_VIEW_SUCCESS,
    payload: result
});

export const runViewFailure = (error) => ({
    type: RUN_VIEW_FAILURE,
    payload: { error }
});

export const getViewDataRequest = (viewId, pageKey = null, limit = 50, append = false) => ({
    type: GET_VIEW_DATA_REQUEST,
    params: { viewId, pageKey, limit, append }
});

export const getViewDataSuccess = (result, append = false) => ({
    type: GET_VIEW_DATA_SUCCESS,
    payload: result,
    append,
});

export const getViewDataFailure = (error) => ({
    type: GET_VIEW_DATA_FAILURE,
    payload: { error }
});

export const getViewHistoryRequest = (viewId, pageKey = null) => ({
    type: GET_VIEW_HISTORY_REQUEST,
    params: { viewId, pageKey }
});

export const getViewHistorySuccess = (result) => ({
    type: GET_VIEW_HISTORY_SUCCESS,
    payload: result
});

export const getViewHistoryFailure = (error) => ({
    type: GET_VIEW_HISTORY_FAILURE,
    payload: { error }
});

export const getUserViewPermissionRequest = (viewId) => ({
    type: GET_USER_VIEW_PERMISSION_REQUEST,
    params: { viewId }
});

export const getUserViewPermissionSuccess = (permission) => ({
    type: GET_USER_VIEW_PERMISSION_SUCCESS,
    payload: { permission }
});

export const getUserViewPermissionFailure = (error) => ({
    type: GET_USER_VIEW_PERMISSION_FAILURE,
    payload: { error }
});

export const getUserViewResourcePermissionRequest = () => ({
    type: GET_USER_VIEW_RESOURCE_PERMISSION_REQUEST,
});

export const getUserViewResourcePermissionSuccess = (permission) => ({
    type: GET_USER_VIEW_RESOURCE_PERMISSION_SUCCESS,
    payload: { permission }
});

export const getUserViewResourcePermissionFailure = (error) => ({
    type: GET_USER_VIEW_RESOURCE_PERMISSION_FAILURE,
    payload: { error }
});
